var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngineeringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#173CBA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_17_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_19---Technology-Engineering",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_133_",
    className: "st0",
    d: "M14.3,294l33.4,5.5c5.3,25.6,15.4,49.9,29.8,71.7l-19.8,27.6c-4.1,5.6-4,13.2,0.2,18.7 c5,6.1,10.3,11.9,15.9,17.5c5.6,5.6,11.5,10.9,17.4,15.9c5.5,4.2,13.2,4.3,18.7,0.2l27.6-19.8c21.8,14.4,46.1,24.5,71.7,29.8 l5.5,33.4c1,6.8,6.5,12.2,13.4,13c4.8,0.5,9.5,0.9,14.4,1.1c2.4,0.1,4.7-0.7,6.4-2.4c1.7-1.6,2.7-3.9,2.7-6.3v-69.5 c0-4.7-3.7-8.5-8.4-8.7c-87.7-4.5-156.5-77-156.5-164.8S155.5,96.7,243.2,92.2c4.7-0.2,8.4-4,8.4-8.7V14c0-2.4-1-4.6-2.7-6.3 c-1.7-1.6-4-2.5-6.4-2.4c-4.9,0.2-9.7,0.5-14.5,1c-6.9,0.9-12.3,6.3-13.4,13.1l-5.5,33.4c-25.6,5.3-49.9,15.4-71.7,29.8 l-27.6-19.8c-5.6-4.1-13.2-4-18.7,0.2c-6.1,5-11.9,10.3-17.4,15.9c-5.6,5.5-10.9,11.4-15.9,17.5c-4.2,5.5-4.3,13.2-0.2,18.8 l19.8,27.6C63.1,164.6,53,189,47.7,214.5L14.3,220c-6.8,1-12.2,6.5-13,13.4c-1.7,15.6-1.7,31.3,0,46.9 C2.1,287.2,7.4,292.8,14.3,294L14.3,294z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_132_",
    className: "st0",
    d: "M243.4,127.1c-68.6,4.3-121.9,61.2-121.9,129.9s53.4,125.6,121.9,129.9 c2.2,0.1,4.3-0.7,5.9-2.2c1.6-1.5,2.4-3.6,2.4-5.8V135.1c0-2.2-0.9-4.3-2.4-5.8C247.7,127.8,245.5,127,243.4,127.1L243.4,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_131_",
    className: "st0",
    d: "M312.4,135.5H269v17.4h43.4c14.4,0,26-11.7,26-26V73.2c12-4.2,19.1-16.5,17-28.9 s-13-21.6-25.7-21.6c-12.7,0-23.5,9.1-25.7,21.6s5,24.7,17,28.9v53.7C321.1,131.6,317.2,135.5,312.4,135.5L312.4,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_130_",
    className: "st0",
    d: "M269,187.6h86.8c4.8,0,8.7-3.9,8.7-8.7s-3.9-8.7-8.7-8.7H269V187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_129_",
    className: "st0",
    d: "M269,378.5h43.4c4.8,0,8.7,3.9,8.7,8.7v53.7c-12,4.2-19.1,16.5-17,28.9 c2.1,12.5,13,21.6,25.7,21.6c12.7,0,23.5-9.1,25.7-21.6c2.1-12.5-5-24.7-17-28.9v-53.7c0-14.4-11.7-26-26-26H269L269,378.5 L269,378.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_128_",
    className: "st0",
    d: "M399.2,291.7H269v17.4h130.2c4.8,0,8.7,3.9,8.7,8.7v45c-12,4.2-19.1,16.5-17,28.9 s13,21.6,25.7,21.6c12.7,0,23.5-9.1,25.7-21.6s-5-24.7-17-28.9v-45C425.2,303.4,413.5,291.8,399.2,291.7L399.2,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_127_",
    className: "st0",
    d: "M486,231c-11,0-20.8,7-24.4,17.4H269v17.4h192.5c4.4,12.4,17.5,19.6,30.4,16.6 c12.9-3,21.4-15.2,19.9-28.3C510.3,240.8,499.2,230.9,486,231L486,231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_126_",
    className: "st0",
    d: "M364.5,335.1c0-4.8-3.9-8.7-8.7-8.7H269v17.4h86.8C360.6,343.8,364.5,339.9,364.5,335.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_125_",
    className: "st0",
    d: "M425.2,196.3v-45c12-4.2,19.1-16.5,17-28.9s-13-21.6-25.7-21.6c-12.7,0-23.5,9.1-25.7,21.6 s5,24.7,17,28.9v45c0,4.8-3.9,8.7-8.7,8.7H269v17.4h130.2C413.5,222.3,425.2,210.6,425.2,196.3L425.2,196.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineeringIcon);
export default __webpack_public_path__ + "static/media/engineering-icon.1b6fe2dd634bef152ca883b325522077.svg";
export { ForwardRef as ReactComponent };